import React from "react";
import NITermsAndConditions from "../NITermsAndConditions";
import ApproverDetailsForm from "../IndividualBidders/ApproverDetailsForm";
import JBSecondaryCompletedComponent from "./JBSecondaryCompletedComponent";
import KycDocumentsUploadComponent from "../IndividualBidders/KycDocumentsUploadComponent";
import JBOfflineViewerFinalSubmission from "./JBOfflineViewerFinalSubmission";

interface JointIndividualOfflineViewerKycStepContentProps {
  activeStep: number;
  bidderUuid: any;
  bidder: any;
  setActiveStep: any;
  init: any;
  offlinePaymentValidation: boolean;
  stepsTitles: Array<{ label: string; value: string }>;
  requiresApproverDetails?: boolean;
}

export default function JointIndividualOfflineViewerKycStepContent({
  activeStep,
  bidderUuid,
  bidder,
  setActiveStep,
  init,
  offlinePaymentValidation,
  stepsTitles,
  requiresApproverDetails = true,
}: JointIndividualOfflineViewerKycStepContentProps) {
  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <KycDocumentsUploadComponent
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            bidderUuid={bidderUuid}
            bidder={bidder}
            init={init}
          />
        );
      case 1:
        return (
          <NITermsAndConditions
            bidderUuid={bidderUuid}
            bidder={bidder}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 2:
      case 3:
        return requiresApproverDetails ? (
          <ApproverDetailsForm
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            outerNextStep="approver_details"
          />
        ) : (
          <JBOfflineViewerFinalSubmission
            bidderUuid={bidderUuid}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 4:
        return (
          <JBSecondaryCompletedComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="p-2 md:p-4 bg-white">
      {activeStep !== 2 && (
        <div className="flex flex-col sm:flex-row justify-end gap-2">
          <div className="flex items-center flex-wrap text-[10px] sm:text-xs">
            <span className="text-brand-orange font-semibold">Offline KYC</span>
            <span className="text-gray-500 font-semibold pl-1">
              → Final bid application must be submitted at the bank.
            </span>
          </div>
        </div>
      )}
      {renderStepContent()}
    </div>
  );
}
